import UpdateBrand from "../../../../components/@products/brands/UpdateBrand";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function BrandUpdatePage() {

    return (
        <UpdateBrand 
            routeType={routeTypes.admin}
        />
    )
}       